module.exports = __webpack_public_path__ + "img/04k-Shop_Persona.10a21bf0.jpg";